import type {
  MeetingPackageCategory,
  CelebrationPackageCategory,
  VenuePackageCategory,
  PackageType,
  PackageVisibilityState
} from 'packages/types';

// The type the package editor and the ordering view open on when nothing
// names one.
export const DEFAULT_PACKAGE_TYPE = 'MEETING_PACKAGE' satisfies PackageType;

export const PackageTypes = [
  DEFAULT_PACKAGE_TYPE,
  'CELEBRATION_PACKAGE',
  'EXPERIENCE_PACKAGE',
  'VENUE_PACKAGE'
] as const satisfies ReadonlyArray<PackageType>;

// NOTE: If you i18n these, make sure to change celebration package editor feature specs, too.
export const PackageTypeLabels: Record<PackageType, string> = {
  MEETING_PACKAGE: 'Meeting packages',
  CELEBRATION_PACKAGE: 'Celebration packages',
  EXPERIENCE_PACKAGE: 'Experience packages',
  VENUE_PACKAGE: 'Venue packages'
};

export const MeetingPackageCategoryLabels: Record<
  MeetingPackageCategory,
  string
> = {
  // NOTE: The order these categories are defined in this object define the
  // order these categories are listed out. So order does matter here!
  half_day: __('meeting_packages.categories.half_day'),
  whole_day: __('meeting_packages.categories.whole_day'),
  two_day: __('meeting_packages.categories.two_day'),
  short: __('meeting_packages.categories.short'),
  breakfast: __('meeting_packages.categories.breakfast'),
  lunch: __('meeting_packages.categories.lunch'),
  evening: __('meeting_packages.categories.evening')
};

export const MeetingPackageCategories = Object.keys(
  MeetingPackageCategoryLabels
) as Array<MeetingPackageCategory>;

export const CelebrationPackageCategoryLabels: Record<
  CelebrationPackageCategory,
  string
> = {
  // NOTE: The order these categories are defined in this object define the
  // order these categories are listed out. So order does matter here!
  party: __('celebration_packages.categories.party'),
  wedding: __('celebration_packages.categories.wedding'),
  pre_christmas_party: __(
    'celebration_packages.categories.pre_christmas_party'
  ),
  sauna: __('celebration_packages.categories.sauna'),
  dinner: __('celebration_packages.categories.dinner'),
  misc: __('celebration_packages.categories.misc')
};

export const CelebrationPackageCategories = Object.keys(
  CelebrationPackageCategoryLabels
) as Array<CelebrationPackageCategory>;

export const VenuePackageCategoryLabels: Record<VenuePackageCategory, string> =
  {
    // NOTE: The order these categories are defined in this object define the
    // order these categories are listed out. So order does matter here!
    hour_based: __('venue_packages.categories.hour_based'),
    day_slot: __('venue_packages.categories.day_slot'),
    evening_slot: __('venue_packages.categories.evening_slot'),
    half_day: __('venue_packages.categories.half_day'),
    whole_day: __('venue_packages.categories.whole_day'),
    whole_weekend: __('venue_packages.categories.whole_weekend'),
    longer: __('venue_packages.categories.longer')
  };

export const VenuePackageCategories = Object.keys(
  VenuePackageCategoryLabels
) as Array<VenuePackageCategory>;

export const PackageVisibilityStateLabels: Record<
  PackageVisibilityState,
  string
> = {
  draft: 'Draft',
  published: 'Published',
  hidden: 'Hidden'
};

export const PackageVisibilityStates = Object.keys(
  PackageVisibilityStateLabels
) as Array<PackageVisibilityState>;
